module.exports = __webpack_public_path__ + "img/web-agency-light.3b0ea0bf.png";